<template>
  <div
    class="grm-video-layer one-fourth column flex justify-center items-center"
    data-grm-comp="RoomCallVideo.mixing"
    ref="roomCallVideo"
    :class="[ {isActiveDrag}, {'no-user': !roomUser}, videoSize, {'participant' : !hasEmceeRole()} ]"
    :data-user-id="videoRect.userId"
    :data-channel-idx="videoRect.idx"
    :data-video-only="this.videoOnly"
    :data-network-status="networkStatus"
    :style="grmVideoLayerStyle(videoRect)"
    :draggable="draggable"
    @touchstart="onTouchStart"
    @dragstart="onDragStart"
    @dragenter="onDragEnter"
    @dragleave="onDragLeave"
    @drop="onDrop"
    @dragover.prevent
    @dragenter.prevent
    @dragleave.prevent
    @drop.prevent.stop
    
    @mouseover="onMouseover"
    @mouseleave="onMouseleave"
    @dblclick.shift.prevent="addByPassSingleVideo(videoRect.userId)"
  >
    <div class="relative w-full h-full"
         ref="roomVideoWrapper">
      <img
        src="@/assets/roomType/lms/img/video-del.svg"
        class="video-del"
        v-if="showDelBtn"
        @click="delVideo"
      />
      <RoomVideo
        data-video-type="myvideo"
        v-if="myPreviewStreams.main"
        ref="myVideo"
        :style="roomVideoStyle"
        :muted="true"
        :videoOnly="videoOnly"
        @pause="loadMyPreviewStream = true"
        @resize="onRoomVideoResize"
      ></RoomVideo>
      <GrmDraggableResizable v-show="roomInfoSetting.useScreenMerger && isScreenShare && !videoOnly && myPreviewStreams.pip"
                             :parent="true"
                             :w="screenSharePip.width"  :h="screenSharePip.height"
                             :x="screenSharePip.x"      :y="screenSharePip.y"
                             :lock-aspect-ratio="screenSharePip.lockAspectRatio"
                             :onResize="onResize"
                             :onDrag="onDrag"
      >
        <RoomVideo class="grm-video"
                   ref="localVideo"
                   :style="roomVideoStyle"
                   :muted="true"
                   :videoOnly="videoOnly"
        ></RoomVideo>
      </GrmDraggableResizable>
    </div>

    <div
      class="v-bg"
         v-if="!isScreenShare && !contentArea"
         :class="{
            'no-cam': !!roomUser && (roomUser.roomUserRole?.camera==false || roomUser.cameraStatus != 'on'),
            'no-user': !roomUser
          }"
    >
      <img v-if="!roomUser" class="pointer-events-none"
           :style="ux.useNoneVideoImageFull && ux.noneVideoImagePath ? {
              width: '100%',
              height: '100%',
              objectFit: 'cover'
           } : {
              height: '40%'
           }"
           :src="ux.noneVideoImagePath || require('@/assets/roomType/lms/img/v-img/user1.svg')"
      />
    </div>

    <template v-if="roomUser">
      <div class="v-peakmeter" :class="{ active: roomUser.isSpeaking && !isScreenShare }"></div>
      <div class="v-dim"
        v-if="!videoRect.screenshare"
      ></div>
      <div v-if="roomGroupGroupName"
           class="v-group"
           :style="{ backgroundColor: groupColor[roomGroup.groupOrder] }">
          <div class="v-group-name">
              {{roomGroupGroupName}}
          </div>
      </div>
      <div class="v-name-area">
        <div class="v-name ep flex items-center" :class="{ isMe }">
          <GrmIcon icon="opener"
                   v-if="isOpener(roomUser.userId)"
                   class="mr-1"
          />
          <p class="room-user-nickname min-w-0 max-w-max flex-1 truncate"
             v-tooltip.top="roomUser.nickname"
          >{{ roomUser.nickname }}</p>
<!--            TODO: roomGroupName 왼쪽 상단 표시 to peter-->
        </div>
        <div
          class="v-mic-off"
          v-if="(roomUser.micStatus === 'off' || roomUser.micStatus === 'none' || roomUser.roomUserRole?.mic === false) && !isScreenShare"
        >
          <img src="@/assets/roomType/lms/img/icon_mic_off.svg" />
        </div>
      </div>
      <RoomSticker class="absolute inset-0" :sticker-id="roomUser.stickerId" />
      <div
        v-if="showParticipationRate && !videoRect.clone && !!roomUser"
        class="v-participation"
      ></div>
      <div v-if="networkStatus !== 0" class="absolute top-0 left-0 p-2">
        <div class="w-7 h-7 rounded-full bg-red-500 flex justify-center items-center">
          <GrmIcon icon="no-signal-white" />
        </div>
      </div>
    </template>

    <div v-if="!isScreenShare"
      class="grm-video-layer-border"
      :style=grmVideoLayerGuideStyle(videoRect)
    ></div>
    <div class="request-speak"
         v-if="isRequestSpeak">
        <div class="request-speak-video-out-line"></div>
        <div class="request-speak-btns-rec">
            <div class="request-speak-btns clearfix"
                 v-if="hasEmceeRole() && !isSmallLayout">
                <button class="request-speak-btn accept"
                        @click="confirmRequestSpeak({reqSpeakId, userId: roomUser.userId, reject:false})">{{ $t('common.apply') }}</button>
                <button class="request-speak-btn refuse"
                        @click="confirmRequestSpeak({reqSpeakId, userId: roomUser.userId, reject:true})">{{ $t('common.reject') }}</button>
            </div>
        </div>
    </div>

    <RoomCallScreenShare v-if="isMyScreenShareView && isScreenShare" />
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'

import { GrmWebRTC } from '@/lib/gooroomee/webrtc/GrmWebRTC'

import RoomVideo from "@/components/Room/Call/RoomVideo";
import RoomCallScreenShare from '@/components/Room/Call/RoomCallScreenShare.vue'
import GrmIcon from "@/components/Common/icon/GrmIcon";
import RoomSticker from "@/components/Room/Sticker/RoomSticker.vue";
import GrmDraggableResizable from "@/components/Common/draggableResizable/GrmDraggableResizable.vue";
import {Room} from "@/core/api/room.api";

export default {
  name: 'RoomCallMixingVideo',
  components: {
    GrmIcon,
    RoomVideo,
    RoomSticker,
    RoomCallScreenShare,
    GrmDraggableResizable,
  },
  props: {
    videoRect: Object,
    roomGroupId: String,
    rectObj: Object,
    videoOnly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      myPreviewStreams: {
        main: null,
        pip: null,
      },
      loadMyPreviewStream: false,
      showDelBtn: false,
      isShowModalList: true,
      isShowModalSelect: false,
      selectedPage: '',
      selectedPosition: '',
      isShowMore: false,
      isActiveDrag: false,
      videoSize: '',
      screenSharePip: {
        x: 0,
        y: 0,
        width: 200,
        height: 200,
        minWidth: 50,
        lockAspectRatio: false,
      },
      groupColor: {
        '1': '#cf304a',
        '2': '#6d00ff',
        '3': '#3748ed',
        '4': '#5587a2',
        '5': '#1daec5',
        '6': '#88b14b',
        '7': '#5c7148',
        '8': '#ca7029',
        '9': '#ef562b',
        '10': '#d13076'
      },
      isRequestSpeak: false,
      reqSpeakId: '',
      networkStatus: 0,
    }
  },

  created() {
    this.$roomApi.addEventListeners((this._Events = _Events()), this)

    this.setDefaultPage();
  },

  mounted() {
    this.setMyPreview();

    const win = this.getDefaultView()
    this.resizeObserver = new ResizeObserver(entries => {
      win.clearTimeout(this._resizeTimer);
      this._resizeTimer = win.setTimeout(() => {
        this.setVideoSize(this?.$refs?.myVideo?.$refs?.video);
        this.onRoomVideoResize();
      }, 100)
    });
    this.$nextTick(() => {
      if(!this?.$refs?.myVideo?.$refs?.video) return;
      this.resizeObserver.observe(this?.$refs?.myVideo?.$refs?.video);
    })
  },

  destroyed() {
    this.$roomApi.removeEventListeners(this._Events)
    this.resizeObserver.disconnect();
  },

  computed: {
    ...mapGetters('user', [
      'me',
      'isOpener',
      'getRoomUser',
      'hasEmceeRole',
      'hasSpeakerRole',
      'hasUserInChannel',
      'isParticipantRole',
      'hasUserInMixingVideo',
      'createMixerChannelRtspUser',
      'getMixerChannelRtspUser'
    ]),
    ...mapGetters('room', [
      'room',
      'isRoomMode',
      'isShowSideWrap',
      'deviceSettings',
      'roomInfoSetting',
      'isScreenShareMode',
      'isRoomTypeWebinar',
      'showParticipationRate',
    ]),
    ...mapGetters('call', [
      'roomCallVideoLayoutCount',
      'pageInfo',
      'isWebinarLive',
      'currentVideoLayout',
      'getRoomCallMixingChannelUserMap'
    ]),
    ...mapGetters('roomGroup', [
      'isInRoomGroup',
      'getRoomGroupName',
      'getRoomGroup'
    ]),
    ...mapGetters('ux', [
      'ux',
    ]),
    
    roomUser() {
      if (this.videoRect.emptyUser) {
        return null;
      }
      let userId = this.videoRect.userId
      let roomUser = this.getRoomUser(userId);
      if (!roomUser && this.roomInfoSetting?.useRtspMixing) {
        let mixerRtspUser = this.createMixerChannelRtspUser(userId);
        this.SET_MIXER_RTSP_USER(mixerRtspUser)

        return this.getMixerChannelRtspUser(userId)
      }
      return roomUser;
    },
    roomGroupGroupName() {
      let roomUser = this.roomUser;
      let parentComponentName = this.$parent.$options._componentTag
      return this.isInRoomGroup(roomUser)
          && parentComponentName !== 'RoomGroupVideoFilmContainer' // 부모 component 가 groupComponent 아닌 경우!
          && this.getRoomGroupName(roomUser.roomGroupId)
    },
    roomGroup() {
      let roomUser = this.roomUser;
      return this.getRoomGroup(roomUser.roomGroupId)
    },
    isMe() {
      return this.roomUser && this.roomUser.userId === this.me.userId;
    },
    draggable() {
      return !this.isScreenShare && !this.isWebinarLive && !this.videoRect.emptyUser && !this.isParticipantRole(this.me)
      //&& !this.videoRect.vip
      //&& !this.videoRect.vad;
    },
    contentArea() {
      // mixing videoLayout 에서 empty flag 로 컨텐츠 영역 설정
      return this.videoRect.empty === true
    },
    isScreenView() {
      return false;
    },
    isMyScreenShareView() {
      return this.isRoomMode('screenShare') && this.isScreenShareMode;
    },
    grmVideoLayerStyle() {
			return videoRect => {
        if (this.isScreenShare)
          return {
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            backgroundColor: 'transparent',
          }
        else
          return {
            width: videoRect.width + 'px',
            height: videoRect.height + 'px',
            left: videoRect.left + 'px',
            top: videoRect.top + 'px',
            backgroundColor: videoRect.emptyUser ? '' : 'transparent',
            pointerEvents: !this.isScreenShare && !this.contentArea ? 'auto' : 'none'
          }
      }
    },
    grmVideoLayerGuideStyle(){
      return videoRect => {
        const {width, height} = this.grmVideoLayerStyle(videoRect);
        return {width, height};
      }
    },
    modalList() {
      return roomUser => {
        let modalList = [{
          title: this.$t('call.mixing.video.show.title'),
          state: this.hasUserInChannel(roomUser) ? 'on' : '',
          onClick: () => { this.handleClickToggleVideoLayout(roomUser) }
        }];

        if (!this.hasSpeakerRole(roomUser)) {
          modalList.unshift({
            title: this.$t('call.mixing.video.move.title'),
            onClick: this.handleClickMoveVideoLayout
          });
        }

        return modalList;
      }
    },
    pages() {
      let pages = [];
      for (let i = 0; this.pageInfo?.totalPageCount > i; i++) {
        pages.push({
          label: this.$t('call.mixing.video.nthPage', { '0' : i+1 })
        })
      }
      return pages;
    },
    positions() {
      let positions = [];
      for (let i = 0; this.roomCallVideoLayoutCount > i; i++) {
        if (this.selectedPage === this.$t('call.mixing.video.firstPage') && i === 0) {
          continue;
        }

        positions.push({
          label: this.$t('call.mixing.video.nth', { '0' : i+1 })
        })
      }
      return positions;
    },
    roomVideoStyle() {
      if(this.isScreenShare && !this.videoOnly) {
        return {};
      }
      else 
        return {
          'object-fit': 'cover',
          'transform': this.isMe && this.deviceSettings.video.usePreviewMirror ? 'scaleX(-1)' : '',
        }
    },
    isScreenShare() {
      return !this.videoOnly
          && (this.videoRect.screenshare || !!this.roomUser?.screenStatus);
    },
    isSmallLayout(){
      return this.currentVideoLayout === 'ml_31_01' || this.currentVideoLayout === 'ml_41_01'
            || this.currentVideoLayout === 'ml_42_01'
    }
  },

  watch: {
    isMe: function(isMe) {
      if (!isMe) {
        this.myPreviewStreams.main = null
      } else {
        this.setMyPreview()
      }
    },
    'myPreviewStreams.main': {
      handler(stream) {
        if (!stream) return
        this.$nextTick(async () => {
          if (!this.$refs.myVideo.$refs.video) return

            this.$refs.myVideo.$refs.video.addEventListener('pause', e => {
                e.target.play().catch(e => {});
            });

          GrmWebRTC.attachMediaStream(this.$refs.myVideo.$refs.video, this.myPreviewStreams.main._v_only_stream || this.myPreviewStreams.main)
          this.$refs.myVideo.$refs.video.play().catch(e => {
              if(!e.message || e.message.includes('interrupted')){
                  return;
              }
              console.warn(e)
          })
        })
      }
    },
    'myPreviewStreams.pip': {
      handler(stream) {
        if (!stream) return
        this.$nextTick(async () => {
          if (!this.$refs.localVideo.$refs?.video) return
          GrmWebRTC.attachMediaStream(this.$refs.localVideo.$refs.video, this.myPreviewStreams.pip)
          this.$refs.localVideo.$refs.video.play().catch(e => {
              if(!e.message || e.message.includes('interrupted')){
                  return;
              }
              console.warn(e)
          })
        })
      }
    },
  },

  methods: {
    ...mapActions('room', [
      'toggleUserMixingVideoByUserId'
    ]),
    ...mapActions('roomGroup', [
      'setRoomUserGroup',
      'eraseRoomGroupUser'
    ]),
    ...mapActions('call', [
      'resizeMergedStream',
      'moveMergedStream',
      'updateMergedScreenStream',
      'getStreamMergerMatrix',
      'getVideoOnlyStream',
    ]),
    ...mapActions('user', [
      'cancelRequestSpeak',
      'confirmRequestSpeak',
    ]),
    ...mapMutations('user', [
      'SET_MIXER_RTSP_USER'
    ]),
    setMyPreview() {
      if (!this.isMe) {
        return
      }

      this.loadMyPreviewStream = false;
      this.myPreviewStreams.pip = null;

      let stream = this.$roomApi.Call.Stream.getCurrentPreviewStream()
      stream = this.$roomApi.Call.Stream.getVideoOnlyStream({stream});

      let refs = {
        myVideo: {
          variable: 'main',
          stream,
        }
      };

      if(this.isScreenShare){
        let screenStream = this.$roomApi.Call.Stream.getCurrentOriScreenStream();
        if(screenStream){
          refs.myVideo.stream = screenStream
          if(this.roomInfoSetting.useScreenMerger) {
            refs.localVideo = {
              variable: 'pip',
              stream
            };
          }
        }else{
          console.warn('screen stream not found!!')
        }
      }

      Object.entries(refs).forEach(([ref, obj]) => {
        const previewVideo = this.$refs[ref]?.$refs.video;
        if (previewVideo?.paused) {
          previewVideo.play().catch(e => {
              if(!e.message || e.message.includes('interrupted')){
                  return;
              }
              console.warn(e)
          });
        }
        if (this.myPreviewStreams[obj.variable] !== obj.stream) {
          this.myPreviewStreams[obj.variable] = obj.stream
        }
      })
    },

    delVideo: function() {
      this.$roomApi.Call.Mixer.changeMixingVideoChannelByUserId({
        userId: this.videoRect.userId,
        channel: -1,
        fromChannel: this.videoRect.idx
      })
    },

    onDragStart(e) {
      if (!this.draggable || !this.hasEmceeRole) {
        return
      }

      if (Room.Call.Mixer.isSingleVideoMode()) {
        this.$alert(this.$t('call.mixing.alert.increaseVideo'))
        e.preventDefault()
        return
      }

      e.stopPropagation()

      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.dropEffect = 'move'
      e.dataTransfer.setData('user_info', JSON.stringify(this.videoRect))

      const img = new Image();
      img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAQAAAAa7ikwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQfmCxEDNCFmuQ4kAAAA+ElEQVRIx91TsQ2DMBB8QyqElEGyARVL0GUDChZgiUjMkBFoKA0dE6RMTY0Egr8UTkJEQmIjUJScZFkv///d+2yivwGumBtPwfr2YD8E3Ts1zf++B0CewxhS3uqFzlXMESaEEEREm3Gj28FUgamg1T24T6CrcHF8eo7gLAN2O+NG43cxXccMtC1wOIC32xUI+n7IqiogigBL39vPBF33/A/KEvA8ogeT54OZyLaHuCiI0pSorheaoGlUBrPagsBInx7B8QiEoco8nwHHMSaYMh1IEsCy1CpLNUUcGxBI+Z5g+KCA76vT0wm8WcDfV4J4vwe77irNX+ECtLmFUHd80+UAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMTEtMTdUMDM6NTI6MzMrMDA6MDCdGSqVAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTExLTE3VDAzOjUyOjMzKzAwOjAw7ESSKQAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMi0xMS0xN1QwMzo1MjozMyswMDowMLtRs/YAAAAASUVORK5CYII=';
      e.dataTransfer.setDragImage(img, 0, 0);
    },
    onDragEnter(e) {
      if (!this.hasEmceeRole) {
        return
      }
      e.stopPropagation()

      if (!e.dataTransfer.types.includes('user_info')) {
        return
      }
      if(!this.isMe){
        this.isActiveDrag = true
      }
    },
    onDragLeave(e) {
      this.isActiveDrag = false
      e.stopPropagation()
    },
    onDrop(e) {
      if (!this.hasEmceeRole) {
        return
      }

      if (Room.Call.Mixer.isSingleVideoMode()) {
        this.$alert(this.$t('call.mixing.alert.increaseVideo'))
        this.$el.dispatchEvent(new Event('dragleave'))
        return
      }

      this.isActiveDrag = false
      let userInfo = e.dataTransfer.getData('user_info')
      if (!userInfo) {
        return
      }
      userInfo = JSON.parse(userInfo)

      e.preventDefault()
      e.stopPropagation()

      let roomUser = this.getRoomUser(userInfo.userId)
      if(this.hasEmceeRole()
          && this.roomGroupId && roomUser.roomGroupId != this.roomGroupId) {
        this.setRoomUserGroup({
          roomGroupId: this.roomGroupId,
          userId: roomUser.userId
        })
        return
      }
      if(this.hasEmceeRole()
          && this.isInRoomGroup(roomUser)
          && (userInfo.roomGroupId && userInfo.roomGroupId !== 'default')
          && (!this.roomGroupId || this.roomGroupId ==='default')
      ) {
        this.eraseRoomGroupUser(roomUser)
        return;
      }

      if (userInfo.idx === this.videoRect.idx) {
        return
      }

      let channel = this.videoRect.idx
      let fromChannel = userInfo.idx

      // if (videoRect.vad) {
      //   if (!this.videoRect.clone) {
      //     return
      //   }
      // }

      if (userInfo.clone) {
        if (!this.videoRect.clone) {
          channel = -1
        }
      }

      // // 첫 페이지 0번째 자리에만 speaker만 이동 가능
      // {
      //   let curPageIndex = this.pageInfo?.curPageIndex
      //   let isFirstPageFirstIndex = curPageIndex == 0 && this.videoRect.idx == 0
      //
      //   if(this.hasSpeakerRole(roomUser)) {
      //     if(!isFirstPageFirstIndex && !this.videoRect.clone) {
      //       return
      //     }
      //   } else if(isFirstPageFirstIndex){
      //     return
      //   }
      // }

      let data = {
        userId: userInfo.userId,
        channel,
        fromChannel
      }
      if(userInfo.roomGroupId && userInfo.roomGroupId !== 'default') {
        data.fromRoomGroupId = userInfo.roomGroupId
      }

      if(this.roomGroupId && this.roomGroupId !== 'default') {
        data.roomGroupId = this.roomGroupId
      }
      this.$roomApi.Call.Mixer.changeMixingVideoChannelByUserId(data)
    },
    onMouseover() {
      this.showDelBtn = !this.videoRect.emptyUser && !!this.videoRect.clone;

      this.onBlurBtn(false);
    },
    onMouseleave() {
      this.showDelBtn = false;

      this.onBlurBtn();


    },

    onBlurBtn(status = true) {
      const vMoreInVideoEl = this.$refs.vMore?.$el;
      if (!vMoreInVideoEl) return;

      vMoreInVideoEl.classList[status ? 'add' : 'remove']('blur');
    },
    resetShowModalState(state = true) {
      this.isShowModalList = state;
      this.isShowModalSelect = !state;
    },
    onClickCloseButton() {
      this.$refs.vMore.handleOutsideClickModal();
    },
    onSelectOption(type, option) {
      this[`selected${type}`] = option.label;
    },
    onClickMoreButton(isShowMore) {
      this.resetShowModalState();
      this.isShowMore = isShowMore;
    },
    onOutsideClickModal(isShowMore) {
      this.resetShowModalState();
      this.isShowMore = isShowMore;
    },
    handleClickMoveUser() {
      const targetPageIndex = Number(this.selectedPage.replace(/[^0-9]/g, '')) - 1;
      const channel = Number(this.selectedPosition.replace(/[^0-9]/g, '')) - 1;

      if (this.hasUserInMixingVideo(this.videoRect.userId, targetPageIndex, channel)) {
        this.$alert({
          text: this.$t('call.mixing.video.move.alert'),
          ok: () => {
            this.changeMixingVideoChannelByUserId(targetPageIndex, channel);
          }
        });

        return;
      }

      this.changeMixingVideoChannelByUserId(targetPageIndex, channel);
    },
    async changeMixingVideoChannelByUserId(targetPageIndex, channel) {
      try {
        await this.$roomApi.Call.Mixer.changeMixingVideoChannelByUserId({
          userId: this.videoRect.userId,
          fromChannel: this.videoRect.idx,
          callerUserId: this.me.userId,
          targetPageIndex,
          channel,
        });
      } catch(e) {
        console.error(e);

        this.$alert({
          text: this.$t('call.mixing.video.move.fail'),
          onlyOk: true
        })
      }

      if (!this.$refs.vMore) return;

      this.$refs.vMore.handleOutsideClickModal();
    },
    handleClickMoveVideoLayout() {
      this.resetShowModalState(false);
    },
    async handleClickToggleVideoLayout(roomUser) {
      try {
        await this.toggleUserMixingVideoByUserId(roomUser);
      } catch(e) {
        this.$alert({
          text: this.$t('call.mixing.video.video.fail'),
          onlyOk: true,
        });
      }
    },
    setDefaultPage() {
      this.selectedPage = this.$t('call.mixing.video.nthPage', { '0' : this.pageInfo?.curPageIndex + 1 });
      this.selectedPosition = this.$t('call.mixing.video.nth', { '0' : this.videoRect.idx + 1 });
    },
    setVideoSize(video){
      const width = video.offsetWidth
      if(width < 43){
        this.videoSize = 'xs'
      } else {
        this.videoSize = ''
      }
    },
    async onRoomVideoResize(){
      this.resizeRoomVideoWrapper();
      if (this.isScreenShare) {
        if (this.roomInfoSetting.useScreenMerger && this.isMe) {
          return this.updatePipLocation();
        }
      }
    },
    async updatePipLocation(){
      await this.updateMergedScreenStream();

      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if(!roomVideoWrapper) return;

      const {clientWidth, clientHeight} = roomVideoWrapper;
      const {canvasRatioX, canvasRatioY, canvasRatioWidth, canvasRatioHeight} = await this.getStreamMergerMatrix();

      this.screenSharePip.lockAspectRatio =  false;
      this.screenSharePip.x = clientWidth * canvasRatioX;
      this.screenSharePip.y = clientHeight * canvasRatioY;
      this.screenSharePip.width = clientWidth * canvasRatioWidth || this.screenSharePip.minWidth;
      this.screenSharePip.height = clientHeight * canvasRatioHeight || (this.screenSharePip.minWidth / canvasRatioWidth * canvasRatioHeight);
      this.$nextTick(() => {
        this.screenSharePip.lockAspectRatio =  true;
      });

    },
    resizeRoomVideoWrapper() {
      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if (!this.isScreenShare) {
        roomVideoWrapper.style.width = roomVideoWrapper.style.height = null
        return
      }

      const roomCallVideo = this.$refs?.roomCallVideo;
      const roomCallVideoRatio = roomCallVideo.clientWidth / roomCallVideo.clientHeight;

      const video = this?.$refs?.myVideo?.$refs?.video;
      const videoTrackSettings = video.srcObject.getVideoTracks()[0].getSettings();
      const videoTrackRatio = videoTrackSettings.width / videoTrackSettings.height;

      // if (videoTrackRatio === 16 / 9) {
      //   return;
      // }

      roomVideoWrapper.style.width = videoTrackRatio >= roomCallVideoRatio ? '100%' : 'auto';
      roomVideoWrapper.style.height = videoTrackRatio > roomCallVideoRatio ? 'auto' : '100%';
    },
    onResize(handle, x, y, width, height){
      if(!this.roomInfoSetting.useScreenMerger) return

      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if(!roomVideoWrapper) return;

      const {clientWidth, clientHeight} = roomVideoWrapper;
      this.resizeMergedStream({
        ratioX: x / clientWidth,
        ratioY: y / clientHeight,        
        ratioWidth: width / clientWidth,
      })
    },
    onDrag(x, y){
      if(!this.roomInfoSetting.useScreenMerger) return

        const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if(!roomVideoWrapper) return;

      const {clientWidth, clientHeight} = roomVideoWrapper;
      this.moveMergedStream({
        ratioX: x / clientWidth,
        ratioY: y / clientHeight
      })
    },

    async addByPassSingleVideo (userId) {
      if(!this.roomUser) return;
      await Room.Call.Mixer.togglePassSingleVideo({targetUserId: userId});
    },
    onTouchStart(e){
      if(!this.hasEmceeRole()){
        e.preventDefault();
      }
    }
  }
}

function _Events(){
  return {
    room_call_loadLocalStreamStart: function() {
      if (!this.isMe) return
    },
    room_call_loadLocalStream: function(e) {
      if (!this.isMe) return
      this.setMyPreview()
    },
    room_core_call_changeUserStream: function(e) {
      if (!this.isMe) return
      this.setMyPreview()
    },
    room_call_loadScreenShareStream: function(e) {
      if (!this.isMe) return
      this.setMyPreview()
    },
    room_user_requestSpeak: function(e){
      const reqUserId = e.userId,
        reqSpeakId = e.data.reqSpeakId
      if(this.videoRect.userId === reqUserId) {
        this.reqSpeakId = reqSpeakId
        this.isRequestSpeak = true
      }
    },
    room_user_cancelRequestSpeak: function(e) {
      const reqUserId = e.userId;

      if(this.videoRect.userId === reqUserId) {
        this.reqSpeakId = ''
        this.isRequestSpeak = false
      }
    },
    room_user_confirmRequestSpeak: function(e) {
      const {reqUserId} = e.data;
      if(this.videoRect.userId === reqUserId) {
        this.reqSpeakId = ''
        this.isRequestSpeak = false
      }
    },
    room_user_changeNetworkStatus: function(e) {
      const { emptyUser, userId } = this.videoRect;
      const { roomUser, levelObj: { level } } = e.data;

      if (
        emptyUser
        || userId !== roomUser.userId
        || this.networkStatus === level
      ) {
        return;
      }

      this.networkStatus = level;
    }
  }
}
</script>

<style lang="scss" scoped>
.grm-video-layer {
  position: absolute !important;
  margin: 0 !important;
  box-sizing: content-box !important;
  overflow: hidden;

  &.participant{
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none
  }
  
  &.isActiveDrag {
    background: #565656 !important;
    opacity: .7;
  }

  .grm-video-layer-border {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    margin: 0;
    border-bottom: 1px solid #0c0c0c;
    border-right: 1px solid #0c0c0c;
    box-sizing: border-box;
    pointer-events: none;
  }

  .v-peakmeter {
    pointer-events: none;
  }

  .video-del {
    z-index: 1;
  }

  .v-group {
    position: absolute;
    top: 0;
    left: 0;
    padding: 4px;
    font-size: 14px;
    color: #fff;
    font-weight: 900;
  }
}

.one-fourth.column {
  position: relative;
  background-color: #394050;

  .network-off {
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .v-bg {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;

    &.no-user {
      background-color: #394050;
    }

    &.no-cam {
      background: #222 url('~@/assets/roomType/lms/img/video-off.svg') no-repeat center / auto 36%;
    }
  }

  .v-dim {
    position: absolute;
    left: 0;
    right: 0;
    height: 16%;
    min-height: 40px;
    bottom: 0;
    background: linear-gradient(
            360deg,
            rgba(0, 0, 0, 0.4) 0%,
            rgba(0, 0, 0, 0) 100%
    );
  }

  .v-peakmeter {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 3px solid $mainColor;
    z-index: 1;
    opacity: 0;
    transition: 0.2s ease-out;
    &.active {
      opacity: 1;
    }
  }

  .v-name-area {
    width: 100%;
    padding: 0 8px 8px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 0 6px;
    position: absolute;
    bottom: 0px;
    box-sizing: border-box;
    text-align: left;

    .v-name {
      min-width: 0;
      flex: 1;
      color: white;
      font-size: 12px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .speaker-img {
        width: 15px;
        height: 15px;
        vertical-align: -2px;
      }

      &.isMe {
        color: #fff700;
      }
    }

    .v-mic-off {
      width: 20px;
      height: 20px;
    }
  }

  .video-del {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    display: none;
  }

  &.xs{
    .v-name-area {
      display: none;
    }
  }

  .room-user-nickname {
    pointer-events: auto;
  }
}

.one-fourth.column:hover .video-del {
  display: block;
}

.v-participation {
  position: absolute;
  top: 60%;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: .4;
  z-index: 1;
}
.request-speak{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  pointer-events: auto !important;
  .request-speak-video-out-line{
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border: 4px solid #59f;
    animation: requestSpeakOutLine 1.5s infinite ease-in-out;
  }
  .request-speak-btns-rec{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 18px;
    text-align: center;
    opacity: .5;
    transition: .2s ease-out;
    .clearfix{
      &::before, &::after{
        content: "";
        display: table;
      }
    }
    .request-speak-btns{
      display: inline-block;
      .request-speak-btn{
        float: left;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        font-size: 1rem;
        color: white;
        box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        opacity: .7;
        pointer-events: auto;
        &.accept{
          background-color: #06f;
        }
        &.refuse{
          margin-left: 10px;
          background-color: #f05;
        }
        &:hover{
          opacity: 1;
        }
      }
    }
  }
}
@keyframes requestSpeakOutLine {
  50% {
    border-width: 12px;
  }
  100% {
    border-width: 4px;
  }
}
</style>